export class MockSharedAppConfiguration {
    instance = "";
    environment = "";
    mamangementUrl = "";
    applicationRoot = "";
    domain = "";
    clientId = "";
    audience = "";
    scope = "";
}
